export const DEFAULT_SERVICE_TYPE_NAME = [
  { name: 'POS' },
  { name: 'Pickup' },
  { name: 'Delivery' },
  { name: 'Quick Pay' },
  { name: 'Kiosk' },
  { name: 'Self Checkout' },
]

export const TIME_ZONES = [
  { name: '(GMT-10:00) Hawaii', uuid: '1', value: 'Hawaii' },
  { name: '(GMT-09:00) Alaska', uuid: '2', value: 'Alaska' },
  {
    name: '(GMT-08:00) Pacific Time (US & Canada)',
    uuid: '3',
    value: 'Pacific Time (US & Canada)',
  },
  {
    name: '(GMT-07:00) Mountain Time (US & Canada)',
    uuid: '5',
    value: 'Mountain Time (US & Canada)',
  },
  { name: '(GMT-07:00) Arizona', uuid: '9', value: 'Arizona' },
  {
    name: '(GMT-06:00) Central Time (US & Canada)',
    uuid: '10',
    value: 'Central Time (US & Canada)',
  },
  {
    name: '(GMT-05:00) Eastern Time (US & Canada)',
    uuid: '7',
    value: 'Eastern Time (US & Canada)',
  },
  {
    name: '(GMT) UTC',
    uuid: '14',
    value: 'UTC',
  },
]

export const DAYS_OF_THE_WEEK = {
  monday: 'MON',
  tuesday: 'TUE',
  wednesday: 'WED',
  thursday: 'THU',
  friday: 'FRI',
  saturday: 'SAT',
  sunday: 'SUN',
}

export const OPENING_HOURS_OPERATING_HOURS = {
  monday: [
    {
      startTime: '',
      endTime: '',
      disabled: true,
      type: 'business_hours',
    },
  ],
  tuesday: [
    {
      startTime: '',
      endTime: '',
      disabled: true,
      type: 'business_hours',
    },
  ],
  wednesday: [
    {
      startTime: '',
      endTime: '',
      disabled: true,
      type: 'business_hours',
    },
  ],
  thursday: [
    {
      startTime: '',
      endTime: '',
      disabled: true,
      type: 'business_hours',
    },
  ],
  friday: [
    {
      startTime: '',
      endTime: '',
      disabled: true,
      type: 'business_hours',
    },
  ],
  saturday: [
    {
      startTime: '',
      endTime: '',
      disabled: true,
      type: 'business_hours',
    },
  ],
  sunday: [
    {
      startTime: '',
      endTime: '',
      disabled: true,
      type: 'business_hours',
    },
  ],
}

export const OPENING_HOURS_ORDER_AHEAD_HOURS = {
  monday: {
    startTime: '',
    endTime: '',
    disabled: true,
    type: 'business_hours',
  },
  tuesday: {
    startTime: '',
    endTime: '',
    disabled: true,
    type: 'business_hours',
  },
  wednesday: {
    startTime: '',
    endTime: '',
    disabled: true,
    type: 'business_hours',
  },
  thursday: {
    startTime: '',
    endTime: '',
    disabled: true,
    type: 'business_hours',
  },
  friday: {
    startTime: '',
    endTime: '',
    disabled: true,
    type: 'business_hours',
  },
  saturday: {
    startTime: '',
    endTime: '',
    disabled: true,
    type: 'business_hours',
  },
  sunday: {
    startTime: '',
    endTime: '',
    disabled: true,
    type: 'business_hours',
  },
}

export const SEARCH_BAR_ITEMS_OPTIONS = [
  {
    uuid: 'name',
    label: 'Name',
  },
  {
    uuid: 'product_sku',
    label: 'Product SKU',
  },
  {
    uuid: 'price',
    label: 'Price',
  },
  {
    uuid: 'display_name',
    label: 'Display Name',
  },
  {
    uuid: 'uuid',
    label: 'UUID',
  },
]

export const venueSettingsItems = [
  // it will be added in the future

  // {
  //   title: 'Max Order Amount (Dollars)',
  //   description:
  //     'This is the maximum dollar amount an order may have',
  //   type: 'number',
  //   name: 'max_order_amount_in_dollars',
  // },
  {
    title: 'Alcohol Limit Message',
    description:
      'This is the message a customer will see when attempting to place an order that contains alcoholic beverages',
    type: 'text',
    name: 'alcohol_limit_message',
  },
  {
    title: 'Alcohol Limit Per Customer',
    description:
      'This is the maximum amount of alcoholic beverages each guest can purchase per order',
    type: 'number',
    name: 'alcohol_limit_per_customer',
  },
  {
    title: 'Alcohol Warning Message',
    description:
      'This is the message a customer sees when placing an order that contains alcoholic beverages. ',
    type: 'text',
    name: 'alcohol_warning_message',
  },
  {
    title: 'Alcohol Warning Message Enabled',
    description:
      'When this setting is enabled, the “Alcohol Warning Message” will be displayed',
    type: 'checkbox',
    name: 'alcohol_warning_message_enabled',
  },
  {
    title: 'Check Recent Order',
    description:
      'When this setting is enabled, duplicate orders will be prevented within a short window of time',
    type: 'checkbox',
    name: 'check_recent_order',
  },
  {
    title: 'Confirmation Numbers Sequential By Stand',
    description:
      'When this setting is enabled, each Revenue Center will receive its own block of order numbers. ',
    type: 'checkbox',
    name: 'confirmation_numbers_sequential_by_stand',
  },
  {
    title: 'Enable Inventory Management',
    description:
      'This setting enables inventory management and automatic stock enabling/disabling',
    type: 'checkbox',
    name: 'enable_inventory_management',
  },
  {
    title: 'Allow Cash Payments on POS',
    description:
      'When this setting is enabled, cash will be accepted throughout the venue. ',
    type: 'checkbox',
    name: 'allow_cash_payments_on_pos',
  },
  {
    title: 'Confirm Suggested Tip Percentage',
    description:
      'When this setting is enabled, POS devices will ask the guest to confirm the tip suggestion when one has not been deliberately selected.',
    type: 'checkbox',
    name: 'confirm_default_tip',
  },
  {
    title: 'Tax by Item',
    description:
      'When this setting is enabled, tax will be calculated by item and not the order total. ',
    type: 'checkbox',
    name: 'tax_by_item',
  },
  {
    title: 'Tax Rate on Item',
    description:
      'When this setting is enabled, a tax rate must be applied to the global items. Venue-level tax will be ignored. *This is required in order to use Menu Manager functionality.',
    type: 'checkbox',
    name: 'tax_rate_on_items',
  },
  {
    title: 'QR Tender Behavior',
    description:
      "This setting determines if the POS should show a QR code that the guest scans through their Wallet, or if the POS should scan the QR code generated from the user's Wallet.",
    type: 'select',
    name: 'qr_tender',
    options: [
      {
        uuid: '#default_empty_value',
        name: 'Default',
      },
      {
        uuid: 'pos_shows_qr',
        name: 'POS Shows QR',
      },
      {
        uuid: 'pos_scans_qr',
        name: 'POS Scans QR',
      },
    ],
  },
]

// filter options: Selected, All (default)
// component: CategoryItems, ModifierGroupAssignedItems
// route: /categories/:uuid,
export const itemsCategoryFilterOptions = [
  {
    label: 'All Items',
    uuid: 'all',
  },
  {
    label: 'Selected Items',
    uuid: 'selected',
  },
]

// filter options: Selected, All (default)
// component: ModifierDrawer
export const MODIFIER_FILTER_OPTIONS = [
  { label: 'All Modifier Groups', uuid: 'all' },
  {
    label: 'Selected Modifier Groups',
    uuid: 'selected',
  },
]

export const MENUS_DRAWER_DOUBLE_TOGGLE_BUTTON_OPTIONS = [
  { label: 'All Menus', uuid: 'All Menus' },
  { label: 'Selected Menus', uuid: 'Selected Menus' },
]

// component: SelectableItemLabel
export const itemInventoryStates = new Map([
  ['available', 'available'],
  ['low_on_inventory', 'low-on-inventory'],
  ['unavailable', 'unavailable'],
])

export const CATEGORY_BANNER_SETTINGS = {
  text: 'The sorting feature in Menu Manager has not been enabled for your organization. Please contact your account manager to enable this feature.',
  linkText: 'Learn More',
}

export const MAX_SELECT_HEIGHT = 400
